import request from '@/utils/request'

// 获取课程列表
export const courseListApi = (data)=>{
	return request("/app/course/my",data,"POST")
}
// 获取课程分类
export const courseTypeApi = (data)=>{
	return request("/app/course/category",data,"GET")
}
// 获取课程详情
export const courseDetailApi = (course_id,data)=>{
	return request(`/app/course/detail/${course_id}`,data,"GET")
}
// 获取课程章节列表
export const courseChapterApi = (course_id,data)=>{
	return request(`/app/course/chapter/${course_id}`,data,"GET")
}

// 添加学习时长
export const courseStudyPoistionApi =(data)=>{
	return request("/app/course/record/add",data,"POST")
}

// 添加学习位置

export const courseStudyLengthApi = pam=>{
	 // 1. 把 pam 对象转成查询字符串
	  const query = Object.entries(pam)
	    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
	    .join('&');
	  // 2. GET 时把参数放到 URL 后面，body 传空
	  return request(`/app/course/learningTime?${query}`, {}, 'GET');
}